<template>
  <div class="section container has-text-centered">
    <h1>FOWLER FAMILY<br>AWARDS CENTER</h1>
    <p class="push push-extra">CELEBRATING</p>
    <h2 class="space is-size-3"><router-link to="/honoree-list/hall-of-fame-inductee">BREITBARD HALL OF FAME</router-link></h2>
    <p class="push">AND</p>
    <h2 class="space is-size-3"><router-link to="/all-honorees">OTHER HONOREES</router-link></h2>
    <p class="push-top push-extra space-top is-size-5">LOCATED IN THE MAIN CONCOURSE OF THE WESTERN METAL SUPPLY CO. BUILDING</p>
  </div>
</template>

<script>
export default {
  name: 'home'
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/helpers.scss';

h1, h2 { 
  font-family: 'DIN Next LT Pro M';
}
h1 {
  font-size: 3.5em;
  line-height: 1em;
}
h2 {
  background-color: rgba(0,0,0,.2);
}
a {
  color: #fff;
}
p:not(:last-child) {
  color: $gold;
  font-family: 'Georgia', serif;
}
p:last-child {
  font-family: 'DIN Next LT Pro M';
  border-top: 1px solid rgba(255,255,255,.35);
}
</style>
